import {Backend} from 'types/api';

export type PdfFilenameElementOption =
    | 'document_type_ja'
    | 'document_type_en'
    | 'document_type_match'
    | 'document_type_legacy'
    | 'document_number'
    | 'document_date'
    | 'document_cost'
    | 'client_name'
    | 'client_name_honorific'
    | 'partner_name_ja'
    | 'partner_name_en'
    | 'partner_name_match';

const PDF_FILENAME_ELEMENTS: PdfFilenameElementOption[] = [
    'document_type_ja',
    'document_type_en',
    'document_type_match',
    'document_type_legacy',
    'document_number',
    'document_date',
    'document_cost',
    'client_name',
    'client_name_honorific',
    'partner_name_ja',
    'partner_name_en',
    'partner_name_match',
];

export type PdfFilenameSectionName =
    | 'pdfFilenameEmployee'
    | 'pdfFilenameClient';

export default PDF_FILENAME_ELEMENTS;

export type PdfFilenameSettingsBackendData = Backend<{
    examples: {
        pdfFilenameClient: Record<string, string>;
        pdfFilenameEmployee: Record<string, string>;
    };
    isUpgradeRequired: boolean;
    mid: string;
    pdfFilenameClient: PdfFilenameElementOption[];
    pdfFilenameEmployee: PdfFilenameElementOption[];
}>;
